export default __webpack_public_path__ + "static/media/sport_icon.68b5a4b6.svg";